// Match the server's access rules: activation is required without entitlement
// history, and expired access is blocked only after explicit restriction.
export const deviceAccessPresentation = (access, isAdmin = false) => ({
  accessRestricted: !isAdmin && (!access || ['Restricted', 'ActivationRequired'].includes(access.status)),
  activationRequired: !isAdmin && access?.status === 'ActivationRequired' && access.canActivateFreePeriod === true,
  accessStatus: access?.status,
  subscriptionAccess: access,
});
